"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelGroupStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
exports.PanelGroupStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  > h2 {
    font-weight: 600;

    > span {
      font-size: 1.5em;
    }
  }

  >.subgroups {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(15em, 1fr));
    grid-gap: 1.5em;
    width: 100%;

    >.subgroup {
      >.panel {
        >.content {
          >.name {
            flex: 1;
            text-align: center;

            span {
              font-size: 0.875em;
            }
          }

          >.count {
            color: ${design_system_1.theme.colors.marine[70]};

            span {
              font-size: 0.875em;
            }
          }
        }
      }
    }
  }
}
`;
//# sourceMappingURL=PanelGroup.styled.js.map